export const cardinalityOptions = [
  {
    value: "one-to-one",
    label: "1:1",
  },
  { value: "one-to-many", label: "1:many" },
  { value: "many-to-one", label: "many:1" },
];
